enum HttpMethods {
  Get = 'get',
  Delete = 'delete',
  Post = 'post',
  Put = 'put',
  Patch = 'patch',
}

export default HttpMethods;
